import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from "react";
import api from "../services/api";
const AuthContext = createContext(null);
// The session itself lives in an httpOnly cookie owned by the API.
// localStorage only caches the (non-sensitive) profile for instant UI;
// GET /auth/me is the source of truth on boot.
const USER_KEY = "user_data";
export function AuthProvider({ children }) {
    const [user, setUser] = useState(() => {
        try {
            const raw = localStorage.getItem(USER_KEY);
            return raw ? JSON.parse(raw) : null;
        }
        catch {
            return null;
        }
    });
    // Validate the cached session against the cookie on boot. A 401 is handled
    // by the api interceptor (clears cache, redirects to login).
    useEffect(() => {
        if (!localStorage.getItem(USER_KEY))
            return;
        api
            .get("/app/auth/me")
            .then((r) => {
            const u = r.data.user;
            const fresh = {
                id: u.id || u._id || "",
                phone: u.phone,
                name: u.name,
                surname: u.surname,
                email: u.email,
            };
            localStorage.setItem(USER_KEY, JSON.stringify(fresh));
            setUser(fresh);
        })
            .catch(() => undefined);
    }, []);
    // token param kept for call-site compatibility; the cookie set by the API
    // is the real session — the token is never persisted.
    function login(_token, userData) {
        localStorage.setItem(USER_KEY, JSON.stringify(userData));
        setUser(userData);
    }
    function logout() {
        api.post("/app/auth/logout").catch(() => undefined);
        localStorage.removeItem(USER_KEY);
        setUser(null);
    }
    function updateUser(patch) {
        setUser((u) => {
            if (!u)
                return u;
            const updated = { ...u, ...patch };
            localStorage.setItem(USER_KEY, JSON.stringify(updated));
            return updated;
        });
    }
    return (_jsx(AuthContext.Provider, { value: { user, isAuthenticated: !!user, login, logout, updateUser }, children: children }));
}
export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx)
        throw new Error("useAuth must be used inside AuthProvider");
    return ctx;
}
